import { render, staticRenderFns } from "./EditGlass.vue?vue&type=template&id=86fbef36&"
import script from "./EditGlass.vue?vue&type=script&lang=js&"
export * from "./EditGlass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports